// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.projects-carousel {
    position: relative;
    padding: 48px 0;
    overflow: hidden;
}

.carousel-track {
    display: flex;
    gap: 24px;
    padding: 24px 0;
    overflow-x: hidden;
    scroll-behavior: smooth;
    align-items: center;
    justify-content: center;
}

.project-card {
    flex: 0 0 340px;
    background: rgba(72, 148, 229, 0.1);
    border: 2px solid rgba(72, 148, 229, 0.3);
    border-radius: 8px;
    padding: 24px;
    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);
    opacity: 0.6;
    transform: scale(0.9);
}

.project-card.center {
    opacity: 1;
    transform: scale(1.05);
    border-color: var(--accent-color-dark);
    box-shadow: 0 8px 24px rgba(72, 148, 229, 0.3);
    background: rgba(72, 148, 229, 0.15);
}

.project-card:hover {
    opacity: 1;
    transform: scale(1.02);
    border-color: var(--secondary-color-dark);
    cursor: pointer;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.project-card.center:hover {
    transform: scale(1.08);
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.project-card img {
    width: 100%;
    height: 180px;
    object-fit: cover;
    border-radius: 6px;
    margin-bottom: 16px;
}

.project-card h3 {
    color: var(--text-color-dark);
    font-size: 24px;
    margin-bottom: 8px;
}

.project-card .tagline {
    color: var(--primary-color-dark);
    font-size: 14px;
    margin-bottom: 12px;
}

.project-card .description {
    color: var(--text-color-dark);
    font-size: 13px;
    line-height: 1.5;
    margin-bottom: 12px;
}

.project-card .status {
    color: var(--secondary-color-dark);
    font-size: 12px;
    display: block;
    margin-bottom: 16px;
}

.project-card-actions {
    display: flex;
    gap: 16px;
    margin-top: 16px;
}

.project-card-actions button,
.project-card-actions a {
    padding: 12px 24px;
    border-radius: 6px;
    font-weight: bold;
    text-decoration: none;
    transition: all 0.2s ease;
    border: none;
    cursor: pointer;
}

.btn-primary {
    background: var(--accent-color-dark);
    color: white;
}

.btn-primary:hover {
    background: var(--secondary-color-dark);
}

.btn-secondary {
    background: transparent;
    color: var(--primary-color-dark);
    border: 2px solid var(--primary-color-dark);
}

.btn-secondary:hover {
    background: var(--primary-color-dark);
    color: var(--background-color-dark);
}

.carousel-nav {
    display: flex;
    justify-content: center;
    gap: 16px;
    margin-top: 24px;
}

.carousel-nav button {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    background: var(--accent-color-dark);
    color: white;
    border: none;
    font-size: 24px;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: center;
}

.carousel-nav button:hover {
    background: var(--secondary-color-dark);
    transform: scale(1.1);
}


`, "",{"version":3,"sources":["webpack://./client/components/pages/Projects/index.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,kBAAkB;IAClB,uBAAuB;IACvB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,eAAe;IACf,mCAAmC;IACnC,yCAAyC;IACzC,kBAAkB;IAClB,aAAa;IACb,iDAAiD;IACjD,YAAY;IACZ,qBAAqB;AACzB;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,sCAAsC;IACtC,8CAA8C;IAC9C,oCAAoC;AACxC;;AAEA;IACI,UAAU;IACV,sBAAsB;IACtB,yCAAyC;IACzC,eAAe;IACf,iDAAiD;AACrD;;AAEA;IACI,sBAAsB;IACtB,iDAAiD;AACrD;;AAEA;IACI,WAAW;IACX,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,kCAAkC;IAClC,eAAe;IACf,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,SAAS;IACT,gBAAgB;AACpB;;AAEA;;IAEI,kBAAkB;IAClB,kBAAkB;IAClB,iBAAiB;IACjB,qBAAqB;IACrB,yBAAyB;IACzB,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,oCAAoC;IACpC,YAAY;AAChB;;AAEA;IACI,uCAAuC;AAC3C;;AAEA;IACI,uBAAuB;IACvB,gCAAgC;IAChC,2CAA2C;AAC/C;;AAEA;IACI,qCAAqC;IACrC,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,oCAAoC;IACpC,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,uCAAuC;IACvC,qBAAqB;AACzB","sourcesContent":[".projects-carousel {\n    position: relative;\n    padding: 48px 0;\n    overflow: hidden;\n}\n\n.carousel-track {\n    display: flex;\n    gap: 24px;\n    padding: 24px 0;\n    overflow-x: hidden;\n    scroll-behavior: smooth;\n    align-items: center;\n    justify-content: center;\n}\n\n.project-card {\n    flex: 0 0 340px;\n    background: rgba(72, 148, 229, 0.1);\n    border: 2px solid rgba(72, 148, 229, 0.3);\n    border-radius: 8px;\n    padding: 24px;\n    transition: all 0.5s cubic-bezier(0.4, 0, 0.2, 1);\n    opacity: 0.6;\n    transform: scale(0.9);\n}\n\n.project-card.center {\n    opacity: 1;\n    transform: scale(1.05);\n    border-color: var(--accent-color-dark);\n    box-shadow: 0 8px 24px rgba(72, 148, 229, 0.3);\n    background: rgba(72, 148, 229, 0.15);\n}\n\n.project-card:hover {\n    opacity: 1;\n    transform: scale(1.02);\n    border-color: var(--secondary-color-dark);\n    cursor: pointer;\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.project-card.center:hover {\n    transform: scale(1.08);\n    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.project-card img {\n    width: 100%;\n    height: 180px;\n    object-fit: cover;\n    border-radius: 6px;\n    margin-bottom: 16px;\n}\n\n.project-card h3 {\n    color: var(--text-color-dark);\n    font-size: 24px;\n    margin-bottom: 8px;\n}\n\n.project-card .tagline {\n    color: var(--primary-color-dark);\n    font-size: 14px;\n    margin-bottom: 12px;\n}\n\n.project-card .description {\n    color: var(--text-color-dark);\n    font-size: 13px;\n    line-height: 1.5;\n    margin-bottom: 12px;\n}\n\n.project-card .status {\n    color: var(--secondary-color-dark);\n    font-size: 12px;\n    display: block;\n    margin-bottom: 16px;\n}\n\n.project-card-actions {\n    display: flex;\n    gap: 16px;\n    margin-top: 16px;\n}\n\n.project-card-actions button,\n.project-card-actions a {\n    padding: 12px 24px;\n    border-radius: 6px;\n    font-weight: bold;\n    text-decoration: none;\n    transition: all 0.2s ease;\n    border: none;\n    cursor: pointer;\n}\n\n.btn-primary {\n    background: var(--accent-color-dark);\n    color: white;\n}\n\n.btn-primary:hover {\n    background: var(--secondary-color-dark);\n}\n\n.btn-secondary {\n    background: transparent;\n    color: var(--primary-color-dark);\n    border: 2px solid var(--primary-color-dark);\n}\n\n.btn-secondary:hover {\n    background: var(--primary-color-dark);\n    color: var(--background-color-dark);\n}\n\n.carousel-nav {\n    display: flex;\n    justify-content: center;\n    gap: 16px;\n    margin-top: 24px;\n}\n\n.carousel-nav button {\n    width: 48px;\n    height: 48px;\n    border-radius: 50%;\n    background: var(--accent-color-dark);\n    color: white;\n    border: none;\n    font-size: 24px;\n    cursor: pointer;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.carousel-nav button:hover {\n    background: var(--secondary-color-dark);\n    transform: scale(1.1);\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
